import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyAAMW_EJ-h0e2HfhZb2jS9WzMp3Q1zGBmc',
  authDomain: 'espacio-trading.firebaseapp.com',
  projectId: 'espacio-trading',
  storageBucket: 'espacio-trading.firebasestorage.app',
  messagingSenderId: '799033150080',
  appId: '1:799033150080:web:7fd9748d5fb3f9cd96b465',
}

const app = initializeApp(firebaseConfig)
const db = getFirestore(app)

export { db }
